import React, { useState } from 'react'
import { Checkbox } from "antd"

import Modal from "../resusable/modal"
import NewInventoryItem from './newinventoryitem'

import { useListData, usePet, useToggle } from '../../modules'
import pluralize from 'pluralize'
import Select from 'react-select'

const RequestItems = ({ toggle, visible, store, onPerform }) => {
    const [bulk, setBulk] = useState()
    const [item, setItem] = useState()
    const [contains, setContains] = useState()
    const [destination, setDestination] = useState()
    const [string, setString] = useState('')
    const [singles, setSingles] = useState()
    const [itms, setItems] = useState([])
    const [stores, setStores] = useState([])

    const [
        { loading: invLoading, fetch: fetchInvItems },
        { list: items = [] }
    ] = useListData('inventoryItems', { string }, { notify: true }, 'items')

    usePet('stores', null, { notify: true, callback: ({ data }) => setStores(data.stores) })

    const onComplete = ({ }, notif, ops) => {
        onPerform()
        notif('Request has been sent', ops('success'))

        setTimeout(toggle, 300)
    }

    const [{ loading }, execute] = usePet('requestItems', {
        source: store?._id,
        destination: destination?._id,
        requests: itms
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Sending request...' } })

    const changeQty = (val, key) => {
        let temp = [...itms]
        temp[key].quantity = val

        setItems(temp)
    }

    const search = str => {
        if (str?.trim()?.length > 2) {
            setString(str)
            fetchInvItems()
        }
    }

    return (
        <Modal
            h="h-auto"
            w="w-4/5 md:w-3/5 xl:w-2/5 mt-5"
            align="items-start"
            title="Request Items"
            toggle={toggle}
            visible={visible}>
            <div className="flex flex-wrap -mx-3 mb-2">
                <div className="w-full md:w-1/2 px-3 md:mb-0">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                        Destination
                    </label>
                    <Select
                        isLoading={invLoading}
                        loadingMessage={str => `Searching for "${str?.inputValue}"`}
                        value={destination}
                        onChange={setDestination}
                        options={stores ? stores.filter(sto => sto.name !== store.name).map(sto => ({ label: sto.name, value: sto._id, ...sto })) : [] }
                        placeholder="Select Destination" />
                </div>
            </div>
            <div className="w-full mb-3">
                <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-username">
                    Items
                </label>
                <Select
                    isMulti
                    isLoading={invLoading}
                    loadingMessage={str => `Searching for "${str?.inputValue}"`}
                    onInputChange={search}
                    value={item}
                    onChange={setItems}
                    options={items.map(itm => ({ label: itm.name, value: itm._id, item: itm._id, quantity: 0, ...itm }))}
                    placeholder="Search for inventory item" />
            </div>
            {
                itms.length > 0 ?
                    <table className="table-auto w-full">
                        {/* Table header */}
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                            <tr>
                                <th className="p-2 pl-4 text-center">
                                    <div className="font-semibold">No.</div>
                                </th>
                                <th className="p-2 pl-4 text-left">
                                    <div className="font-semibold">Item</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-center">Quantity</div>
                                </th>
                            </tr>
                        </thead>
                        {/* Table body */}
                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                            {
                                itms.map((item, key) =>
                                    <tr>
                                        <td className="p-2 pl-4 h-5 text-center">{key + 1}</td>
                                        <td className="p-2 pl-4 h-5">{item.name}</td>
                                        <td className="p-2 pl-4 h-5 text-center">
                                            <input
                                                className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                                                id="grid-qty-item"
                                                value={ item.quantity }
                                                onChange={ e => changeQty(e.target.value, key) }
                                                placeholder={ `How many ${item.receivedIn.toLowerCase()}?` }
                                                type="number"/>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    : <div className="align-center flex w-full">
                        <h2>Please add some items above</h2>
                    </div>

            }
            <div className="flex justify-end">
                <button disabled={loading} onClick={execute} className="text-white hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center">Send Request</button>
            </div>
        </Modal>
    )
}

export default RequestItems